"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newRenderingWorker = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var uuid_1 = require("uuid");
var events_1 = require("../../events");
var render_1 = require("../../events/render");
function wait(ms) {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.delay(ms)];
            case 1:
                _a.sent();
                return [2 /*return*/, true];
        }
    });
}
var isAsyncRenderResolvedEvent = function (id) {
    return events_1.newDashboardEventPredicate("GDC.DASH/EVT.RENDER.ASYNC.RESOLVED", id ? function (e) { return e.payload.id === id; } : function () { return true; });
};
var isAsyncRenderRequestedEvent = function (id) {
    return events_1.newDashboardEventPredicate("GDC.DASH/EVT.RENDER.ASYNC.REQUESTED", id ? function (e) { return e.payload.id === id; } : function () { return true; });
};
function newRenderingWorker(config) {
    if (config === void 0) { config = {
        asyncRenderRequestedTimeout: 2000,
        asyncRenderResolvedTimeout: 2000,
        maxTimeout: 20 * 60000,
        correlationIdGenerator: uuid_1.v4,
    }; }
    return function renderingWorker(ctx) {
        var correlationId, asyncRenderTasks, err_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 7]);
                    correlationId = config.correlationIdGenerator();
                    // First, notify that the rendering of the whole dashboard started.
                    return [4 /*yield*/, effects_1.put(render_1.renderRequested(ctx, correlationId))];
                case 1:
                    // First, notify that the rendering of the whole dashboard started.
                    _a.sent();
                    // Wait for the dashboard initialization.
                    return [4 /*yield*/, effects_1.take("GDC.DASH/EVT.INITIALIZED")];
                case 2:
                    // Wait for the dashboard initialization.
                    _a.sent();
                    return [4 /*yield*/, effects_1.call(collectAsyncRenderTasks, config)];
                case 3:
                    asyncRenderTasks = _a.sent();
                    // Wait for the resolution of all async rendering tasks.
                    return [4 /*yield*/, effects_1.call(waitForAsyncRenderTasksResolution, asyncRenderTasks, config)];
                case 4:
                    // Wait for the resolution of all async rendering tasks.
                    _a.sent();
                    // Notify that the dashboard is fully rendered.
                    return [4 /*yield*/, effects_1.put(render_1.renderResolved(ctx, correlationId))];
                case 5:
                    // Notify that the dashboard is fully rendered.
                    _a.sent();
                    return [3 /*break*/, 7];
                case 6:
                    err_1 = _a.sent();
                    console.error("Rendering worker failed", err_1);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    };
}
exports.newRenderingWorker = newRenderingWorker;
function collectAsyncRenderTasks(config) {
    var asyncRenderTasks, timeout, renderRequestedChannel, _a, asyncRenderRequested, timeoutResolved, asyncRenderId, asyncRenderTask;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                asyncRenderTasks = new Map();
                return [4 /*yield*/, effects_1.spawn(wait, config.asyncRenderRequestedTimeout)];
            case 1:
                timeout = _b.sent();
                return [4 /*yield*/, effects_1.actionChannel(isAsyncRenderRequestedEvent())];
            case 2:
                renderRequestedChannel = _b.sent();
                _b.label = 3;
            case 3:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.race({
                        asyncRenderRequested: effects_1.take(renderRequestedChannel),
                        timeoutResolved: effects_1.join(timeout),
                    })];
            case 4:
                _a = _b.sent(), asyncRenderRequested = _a.asyncRenderRequested, timeoutResolved = _a.timeoutResolved;
                if (timeoutResolved) {
                    return [3 /*break*/, 6];
                }
                asyncRenderId = asyncRenderRequested.payload.id;
                // Check whether async render is already registered.
                // If so, skip it, because possible re-executions are covered in the async render task itself.
                if (asyncRenderTasks.has(asyncRenderId)) {
                    return [3 /*break*/, 3];
                }
                return [4 /*yield*/, effects_1.spawn(waitForAsyncRenderResolution, asyncRenderId, config)];
            case 5:
                asyncRenderTask = _b.sent();
                asyncRenderTasks.set(asyncRenderId, asyncRenderTask);
                return [3 /*break*/, 3];
            case 6: return [2 /*return*/, asyncRenderTasks];
        }
    });
}
function waitForAsyncRenderTasksResolution(asyncRenderTasks, config) {
    var timeout, renderRequestedChannel, asyncRenderTasksList, _a, asyncTasksResolved, asyncRenderRequested, timeoutResolved, asyncRenderId, asyncRenderTask;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.spawn(wait, config.maxTimeout - config.asyncRenderRequestedTimeout)];
            case 1:
                timeout = _b.sent();
                return [4 /*yield*/, effects_1.actionChannel(isAsyncRenderRequestedEvent())];
            case 2:
                renderRequestedChannel = _b.sent();
                _b.label = 3;
            case 3:
                if (!true) return [3 /*break*/, 9];
                asyncRenderTasksList = Array.from(asyncRenderTasks, function (_a) {
                    var _b = tslib_1.__read(_a, 2), task = _b[1];
                    return task;
                });
                return [4 /*yield*/, effects_1.race({
                        asyncRenderRequested: effects_1.take(renderRequestedChannel),
                        asyncTasksResolved: effects_1.all(asyncRenderTasksList.map(function (task) { return effects_1.join(task); })),
                        timeoutResolved: effects_1.join(timeout),
                    })];
            case 4:
                _a = _b.sent(), asyncTasksResolved = _a.asyncTasksResolved, asyncRenderRequested = _a.asyncRenderRequested, timeoutResolved = _a.timeoutResolved;
                if (!(timeoutResolved || asyncTasksResolved)) return [3 /*break*/, 6];
                asyncRenderTasksList.forEach(function (task) { return task.cancel(); });
                return [4 /*yield*/, effects_1.cancel(timeout)];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6:
                if (!asyncRenderRequested) return [3 /*break*/, 8];
                asyncRenderId = asyncRenderRequested.payload.id;
                // Check whether async render is already registered.
                // If so, skip it, because possible re-executions are covered in the async render task itself.
                if (asyncRenderTasks.has(asyncRenderId)) {
                    return [3 /*break*/, 3];
                }
                return [4 /*yield*/, effects_1.spawn(waitForAsyncRenderResolution, asyncRenderId, config)];
            case 7:
                asyncRenderTask = _b.sent();
                asyncRenderTasks.set(asyncRenderId, asyncRenderTask);
                _b.label = 8;
            case 8: return [3 /*break*/, 3];
            case 9: return [2 /*return*/];
        }
    });
}
function waitForAsyncRenderResolution(id, config) {
    var maxRetries, retries, renderResolvedChannel, timeout;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                maxRetries = 3;
                retries = 0;
                return [4 /*yield*/, effects_1.actionChannel(isAsyncRenderResolvedEvent(id))];
            case 1:
                renderResolvedChannel = _a.sent();
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(renderResolvedChannel)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.race({
                        timeout: effects_1.call(wait, config.asyncRenderResolvedTimeout),
                        anotherExecution: effects_1.take(isAsyncRenderRequestedEvent(id)),
                    })];
            case 4:
                timeout = (_a.sent()).timeout;
                retries += 1;
                // No re-execution, or max retry limit reached - leave the loop
                if (timeout || retries === maxRetries) {
                    return [2 /*return*/];
                }
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=renderingWorker.js.map